import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useBadgeVariant } from "@hooks/useBadgeVariant";
import type { ReleaseHeadsetRow } from "types/headsetReleaseTypes";
import { STATUS_COLORS } from "./releaseFormat";

type HeadsetStatusBadgeProps = Pick<ReleaseHeadsetRow, "status" | "reason">;

export function HeadsetStatusBadge({ status, reason }: HeadsetStatusBadgeProps) {
  const { t } = useTranslation();
  const badgeVariant = useBadgeVariant();
  const detail = reason ? t(`headsetReleases.reason.${reason}`, { defaultValue: reason }) : "";
  return (
    <Badge
      color={STATUS_COLORS[status]}
      variant={badgeVariant === "filled" && status === "skipped" ? "outline" : badgeVariant}
    >
      {t(`headsetReleases.status.${status}`)}
      {detail && ` · ${detail}`}
    </Badge>
  );
}
